import PaymentTerm from "@/models/paymentterm";
import BaseProvider from "./baseprovider"

export default class PaymentTermProvider extends BaseProvider {
    public async fetchPaymentTerms(): Promise<PaymentTerm[]> {
        const response = await (await this.getApiV2()).get('/PaymentTerms');

        const titles = response.data.map((d: any) => this.getPaymentTerm(d));

        return titles;
    }

    public async getPaymentTermFromId(paymentTermId: number): Promise<PaymentTerm> {
        const response = await (await this.getApiV2()).get(`/paymentterms/${paymentTermId}`);

        const paymentTerm = this.getPaymentTerm(response.data);

        return paymentTerm;
    }

    private getPaymentTerm(data: any): PaymentTerm {
        const paymentTerm = new PaymentTerm(data);

        return paymentTerm;
    }
}